import { gql } from '@apollo/client/core';

export const GET_MAGISTRADOS = gql`
  query GetMagistrados($nuMatricula: String!) {
    magistradosAll(nuMatricula: $nuMatricula) {
      nuFuncionario
      nuMatricula
      nuCPF
      nmFuncCompleto
      deMagistrado
    }
  }
`;

export const GET_CATEGORIAS = gql`
  query GetCategorias($deCategParecer: String!) {
    categPareceres(deCategParecer: $deCategParecer) {
      cdCategParecer
      deCategParecer
    }
  }
`;

export const GET_RELATORES = gql`
  query GetRelatores($nmRelator: String!) {
    relatores(nmRelator: $nmRelator) {
      cdRelator
      nmRelator
    }
  }
`;

export const GET_PROLATORES = gql`
  query GetProlatores($nmProlator: String!) {
    prolatores(nmProlator: $nmProlator) {
      cdProlator
      nmProlator
    }
  }
`;

export const GET_CARTORIOS = gql`
  query GetCartorios($deTipoCartorio: String!) {
    tipoCartorios(deTipoCartorio: $deTipoCartorio) {
      cdTipoCartorio
      deTipoCartorio
    }
  }
`;

export const GET_VARAS = gql`
  query GetVaras($nmVara: String!) {
    varas(nmVara: $nmVara) {
      cdVara
      nmVara
    }
  }
`;

export const GET_COMARCAS = gql`
  query GetComarcas($nmComarca: String!) {
    comarcas(nmComarca: $nmComarca) {
      cdComarca
      nmComarca
    }
  }
`;

export const GET_CLASSES = gql`
  query GetClasses($deClasse: String!) {
    classes(deClasse: $deClasse) {
      cdClasse
      deClasse
    }
  }
`;

export const GET_BOLETINS = gql`
  query GetBoletins($nmTipoBoletim: String!) {
    tipoBoletins(nmTipoBoletim: $nmTipoBoletim) {
      cdTipoBoletim
      nmTipoBoletim
      flJurisprudencia
    }
  }
`;

export const GET_TIPO_NORMA = gql`
  query GetTipoNorma($deTipoNorma: String!) {
    tipoNormas(deTipoNorma: $deTipoNorma) {
      cdTipoNorma
      deTipoNorma
    }
  }
`;

export const GET_AUTORES = gql`
  query GetAutores($nmAutor: String!) {
    autores(nmAutor: $nmAutor) {
      cdAutor
      nmAutor
    }
  }
`;

export const GET_EDITORAS = gql`
  query GetEditoras($nmEditora: String!) {
    editoras(nmEditora: $nmEditora) {
      cdEditora
      nmEditora
    }
  }
`;

export const GET_ORGAO_EXPEDITOR = gql`
  query GetOrgaoExpedidor($nmOrgaoExpedidor: String!) {
    orgaosExpedidores(nmOrgaoExpedidor: $nmOrgaoExpedidor) {
      cdOrgaoExpedidor
      nmOrgaoExpedidor
    }
  }
`;

export const GET_FONTE = gql`
  query GetFonte($sgFonte: String!) {
    fontes(sgFonte: $sgFonte) {
      cdFonte
      sgFonte
    }
  }
`;

export const GET_ASSUNTOS = gql`
  query GetAssuntos($deAssunto: String!) {
    assuntos(deAssunto: $deAssunto) {
      cdAssunto
      deAssunto
    }
  }
`;
